// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js??ref--5-1!./iconfont.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("a6ee33f2", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/iconfont.css
// module id = TzC8
// module chunks = 38